<template>
  <div class="feedback-slider">
    <p class="title">{{ this.text.feedback.title }}</p>
    <divider-line />
    <div class="col-12 col-lg-10 mx-auto">
      <carousel :items-to-show="1" :transition="400" :wrapAround="true" :autoplay="1118000">
        <slide v-for="(feedback, i) in text.feedback.list.slice().reverse()" :key="i">
          <div class="col-11 col-lg-6 mx-auto">
            <div class="card">
              <div data-aos="fade-up" class="icon-container">
                <i class="icon fa-solid fa-quote-right"></i>
              </div>
              <div class="card-body d-flex flex-column align-items-center justify-content-center">
                <p v-html="feedback.description" class="description"></p>
                <p class="text-white"><b>{{feedback.master}}</b><br/><span>{{ feedback.date }}</span></p>
              </div>
              <div class="counter-container">
                <p class="counter">{{(i+1)}}/{{text.feedback.list.length}}</p>
              </div>
            </div>
          </div>
          <div class="mx-auto d-lg-block d-none">
            <div style="width: 450px; margin: 0 auto;">
              <div :data-aos="'zoom-in'" data-aos-anchor-placement="top-bottom">
                <picture>
                  <source :srcset="feedback.imageWebP" type="image/webp">
                  <img class="picture" :src="feedback.image" :alt="text.alt" style="width: 100%; height: auto; display: block;">
                </picture>
              </div>
            </div>
          </div>
        </slide>
        <template #addons>
          <CarouselNavigation class="d-none d-lg-flex" />
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>

import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation as CarouselNavigation } from 'vue3-carousel';
import json from '../../text.json'
import DividerLine from '@/components/dividerLine.vue'

export default {
  name: "service-slider",

  components: {
    Carousel,
    Slide,
    DividerLine,
    CarouselNavigation
  },

  data() {
    return {
      text: json,
      display: 0
    }
  }
}
</script>

<style scoped>

</style>
